import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from '@/plugins/vuetify'
import '@/assets/styles/main.scss'
import Axios from "axios";
import VueAxios from "vue-axios";


Vue.config.productionTip = true;

Vue.use(VueAxios, Axios);
Axios.defaults.baseURL = process.env.VUE_APP_ROMA_ENCUESTA_API_URL;
Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

// add cookies to axios
Axios.defaults.withCredentials = true;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
